import { track } from '@updater-core/lib/tracker';
import { gateway as createGateway } from '../../components/steps/home-services-app/app/gateway';
import { actions } from './home-services.actions';
import { selectors as current } from '../current';
import { selectors as session } from '../session';
import * as sessionMatchers from '../session/session.matchers';
import { getResponseHeaders } from '../session/session.epic';
import { SESSION_HEADERS } from '../../constants';
import { ENVIRONMENT } from '../../environment';

export const isNewMove = (action) =>
  action.type === '@@reduxUiRouter/$stateChangeSuccess' &&
  (action.payload.currentState.name === 'app.dashboard' ||
    action.payload.currentState.name === 'app.dashboard.new-move') &&
  action.payload.currentParams.moveId;

export function HomeServicesEpic() {
  return async (action, { dispatch, getState }) => {
    if (
      sessionMatchers.isCreateSuccess(action) ||
      sessionMatchers.isReadSuccess(action) ||
      isNewMove(action)
    ) {
      const responseHeaders = action.meta
        ? getResponseHeaders(action.meta.response, SESSION_HEADERS)
        : session.headers(getState());

      const moveId =
        action.payload && action.payload.currentParams
          ? action.payload.currentParams.moveId
          : current.user(getState()).moveId(getState());

      const gateway = createGateway({
        sessionHeaders: responseHeaders,
        env: ENVIRONMENT,
        moveId,
        tracker: {
          track: (attributes) =>
            track({
              domain: 'home_services',
              ...attributes,
            }),
        },
      });

      const { propertyConfig } = await gateway.getPropertyConfig(moveId);

      dispatch(actions.setHomeServicesPropertyConfig(propertyConfig));

      const searchHomeServicesOffers =
        (await gateway.searchOffers({ propertyConfig })) || [];

      dispatch(actions.setHomeServicesOffers(searchHomeServicesOffers));
    }
  };
}
